import { useEffect, useState } from "react";
import { getSecurityCenterData } from "../../../api/securityCenterService";

function SecurityCenterPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            setLoading(true);

            try {
                const result = await getSecurityCenterData();
                setData(result);
            } catch (err) {
                console.error("Security Center load failed", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    if (loading) {
        return <div style={{ padding: 20 }}>Loading Security Center...</div>;
    }

    if (!data) {
        return <div style={{ padding: 20 }}>Security data not available.</div>;
    }

    return (
        <div style={{ padding: 20 }}>
            <h2>Security Center</h2>

            <p style={{ color: "#666" }}>
                Unified security monitoring for authentication, encryption, blockchain, IoT and threat detection.
            </p>

            <div style={gridStyle}>
                <Card title="API Status" value={data.apiStatus} color="#2E7D32" />
                <Card title="JWT" value={data.jwtStatus} color="#1565C0" />
                <Card title="2FA" value={data.twoFactorStatus} color="#6A1B9A" />
                <Card title="Encryption" value={data.encryptionStatus} color="#00897B" />
                <Card title="Failed Logins" value={data.failedLogins} color="#C62828" />
                <Card title="Blocked Users" value={data.blockedUsers} color="#EF6C00" />
                <Card title="Users" value={data.users} color="#3949AB" />
                <Card title="IoT Online" value={`${data.onlineDevices}/${data.iotDevices}`} color="#7B1FA2" />
                <Card title="Blockchain Events" value={data.blockchainEvents} color="#546E7A" />
                <Card title="AI Threat Score" value={`${data.threatScore}%`} color={data.threatScore > 25 ? "#C62828" : "#2E7D32"} />
            </div>

            <div style={panelStyle}>
                <h3>Latest Security Events</h3>

                {data.securityEvents.length === 0 ? (
                    <p>No security events found.</p>
                ) : (
                    <div style={{ display: "grid", gap: 10 }}>
                        {data.securityEvents.map((event, index) => (
                            <div key={event.id || index} style={eventStyle}>
                                <b>{event.eventType || event.type || "Security Event"}</b>
                                <br />
                                {event.message || event.description || "No message"}
                                <br />
                                <span style={{ color: "#777", fontSize: 12 }}>
                                    {event.createdAt || event.timestamp || "�"}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

function Card({ title, value, color }) {
    return (
        <div style={{ ...cardStyle, borderTop: `6px solid ${color}` }}>
            <div style={{ color: "#666", fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 30, fontWeight: "bold", marginTop: 10 }}>
                {value}
            </div>
        </div>
    );
}

const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
    marginTop: 20,
};

const cardStyle = {
    background: "white",
    borderRadius: 12,
    padding: 18,
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
};

const panelStyle = {
    marginTop: 24,
    background: "white",
    borderRadius: 12,
    padding: 18,
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
};

const eventStyle = {
    borderBottom: "1px solid #eee",
    paddingBottom: 8,
};
export default SecurityCenterPage;